import { SearchProps, useSearch } from "@usereactify/search";
import React from "react";

export type SearchFormProps = React.ComponentProps<NonNullable<SearchProps["render"]>>;

export const SearchForm: React.FC = (props) => {
  const { searchTerm, setSearchTerm, submitSearchTerm } = useSearch();

  const handleFormSubmit = React.useCallback(
    (event: React.FormEvent<HTMLFormElement>) => {
      event.preventDefault();
      submitSearchTerm();
    },
    [submitSearchTerm]
  );

  const handleInputChange = React.useCallback(
    (event: React.ChangeEvent<HTMLInputElement>) => {
      setSearchTerm(event.target.value);
    },
    [setSearchTerm]
  );

  return (
    <form onSubmit={handleFormSubmit}>
      <input type="search" placeholder="Search..." value={searchTerm} onChange={handleInputChange} />
    </form>
  );
};
